import 'vant/es/toast/style';
export default {
  data() {
    return {
      lang: 'hk',
      userTerms: [{
        type: 'title',
        hkText: "網上私隱政策聲明"
      }, {
        type: 'subT',
        hkText: "聲明"
      }, {
        type: 'content',
        hkText: "私隱政策聲明是監管香港教育圖書有限公司網站www.hkep.com, www.parentnet.hk來收集收集、利用、保留和披露用戶資訊的方法。及要說明此聲明是根據及符合香港特別行政區個人資料（私隱）條例（條例）， 適用於所有香港教育圖書有限公司，以下簡稱[教圖]電子平台提供的所有服務。"
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '個人資料'
      }, {
        type: 'content',
        hkText: '教圖將以不同方法收集識別個人身份的資料，包括但不限於當用戶瀏覽網站、登記電郵提示，以及聯繫網站所提供的其他活動、服務、功能或資源時。在適當情況下，用戶可能會被問及姓名、電郵地址、郵寄地址、電話號碼。用戶可以不記名方式瀏覽網站，我們只在用戶自願提交的情況下才收集識別個人身份的資料。用戶可拒絕提供識別個人身份的資料，除非這致使他們不能參與某些網站相關的活動。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '非個人資料'
      }, {
        type: 'content',
        hkText: '用戶在瀏覽或使用教圖各電子平台時，我們可能會收集非個人身份識別資料。非個人身份識別資料可包括與用戶聯繫本平台方式有關的瀏覽名稱、電腦類型及技術資料，如所使用的操作系統、網絡服務供應商及其他類似資料。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '可能持有的個人資料類型包括那幾項：(以下是例子)'
      }, {
        type: 'content',
        hkText: '1. 姓名'
      }, {
        type: 'content',
        hkText: '2. 聯絡資料包括聯絡姓名、地址、電話號碼、傳真號碼、電郵地址'
      }, {
        type: 'content',
        hkText: '3. 家長會識別資料包括姓名和會籍資料'
      }, {
        type: 'content',
        hkText: '4. 登入帳戶及該帳戶處理系統識別資料，包括登入名稱、密碼、姓名、就讀／曾就讀學校名稱、班別、級別、登記號碼、STRN、電郵地址、郵寄地址、電話號碼'
      }, {
        type: 'content',
        hkText: '5. 教育水平'
      }, {
        type: 'content',
        hkText: '6. 就讀／曾就讀學校資料，包括學校名稱、地址、感興趣的學科、採用及購買資料的記錄（如教科書等）'
      }, {
        type: 'content',
        hkText: '7. 任職學校資料，包括學校名稱、地址、感興趣的學科、任教的學科'
      }, {
        type: 'content',
        hkText: '8. 瀏覽互動內容的結果、記錄及累積進度'
      }, {
        type: 'content',
        hkText: '9. 職業、職位、任職年期'
      }, {
        type: 'content',
        hkText: '10. 建議、個人意見、查詢'
      }, {
        type: 'content',
        hkText: '11. 興趣和嗜好'
      }, {
        type: 'content',
        hkText: '12. 互聯網瀏覽器類型及版本*'
      }, {
        type: 'content',
        hkText: '13. 個人電腦操作系統*'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '如何收集個人資料(以下是例子)'
      }, {
        type: 'content',
        hkText: '1. 教圖可能會在訪客於網站進行以下活動時收集個人資料：'
      }, {
        type: 'content',
        hkText: '　1.1 瀏覽網站（包括所有合作夥伴的網站、帳戶處理系統、教師資源中心、教師網、及公司網站的其他網頁）'
      }, {
        type: 'content',
        hkText: '　1.2. 下載申請表、在網上訂閱特定課題的資料'
      }, {
        type: 'content',
        hkText: '　1.3. 登記任何個人帳戶或學校帳戶'
      }, {
        type: 'content',
        hkText: '　1.4. 以電郵作查詢'
      }, {
        type: 'content',
        hkText: '　1.5. 瀏覽互動內容'
      }, {
        type: 'content',
        hkText: '　1.6. 填寫問卷、調查或'
      }, {
        type: 'content',
        hkText: '　1.7. 參加比賽；申請參加研討會、推廣活動或訓練課程'
      }, {
        type: 'content',
        hkText: '2. 教圖可能會進行後續研究以收集個人資料，來源可能包括個人資料及其他在全球資訊網、政府刊物、報章、雜誌、註冊機構公布的其他訊息，以及任何向公眾發放的其他訊息。'
      }, {
        type: 'content',
        hkText: '3. 教圖同時於各種初步研究獲取個人資料，如銷售探訪、個人及電話訪談、焦點小組討論等。'
      }, {
        type: 'content',
        hkText: '4. 教圖可能收集你向集團旗下機構所提供的個人資料，你同意該機構與教圖共享相關的個人資料。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '#Cookies 及域名伺服器地址'
      }, {
        type: 'content',
        hkText: '1. 教圖網站伺服器可能會收集有關訪客網上環節的相關資料，旨在提供伺服器的累計、不記名及統計資料，以便教圖更能滿足網站訪客的需求及期望。資料類別包括：'
      }, {
        type: 'content',
        hkText: '　-瀏覽器類型及版本'
      }, {
        type: 'content',
        hkText: '　-曾瀏覽的網頁'
      }, {
        type: 'content',
        hkText: '　-瀏覽次數及持續時間'
      }, {
        type: 'content',
        hkText: '　-瀏覽互動內容的結果、記錄及累積進度'
      }, {
        type: 'content',
        hkText: '　-操作系統；或'
      }, {
        type: 'content',
        hkText: '　-域名伺服器地址及／或域名'
      }, {
        type: 'content',
        hkText: '2. 某些網頁可能會於訪客瀏覽器設置 Cookie，藉以提供個人化服務，以及／或在單一環節裡的不同頁面保留其個人身份。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '收集個人資料的目的'
      }, {
        type: 'content',
        hkText: '收集個人資料的目的可包括：'
      }, {
        type: 'content',
        hkText: '1. 寄出有關教圖活動、比賽、推廣和計劃的書面通知'
      }, {
        type: 'content',
        hkText: '2. 寄出透過網站提供的服務及其他相關產品和服務的書面通知'
      }, {
        type: 'content',
        hkText: '3. 書籍、光碟、錄音帶及其他相關教學和學習資源的市場推廣'
      }, {
        type: 'content',
        hkText: '4. 與第三方機構進行顧客、產品及服務調查、活動以及聯合推廣'
      }, {
        type: 'content',
        hkText: '5. 評估及進一步改良公司的產品和服務'
      }, {
        type: 'content',
        hkText: '6. 處理遊戲、抽獎以及推廣活動'
      }, {
        type: 'content',
        hkText: '7. 提供電子教學資源及有用的網絡連結'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '個人資料轉讓情況'
      }, {
        type: 'content',
        hkText: '1. 教圖不會出售、交易或租借識別個人身份的資料予他人，亦不會在未經客戶的同意下，讓不相關的第三方機構使用客戶的個人資料以作推廣用途。'
      }, {
        type: 'content',
        hkText: '2. 教圖可能會將訪客和用戶的一般性累計人口資料 （與個人識別資料無關的資料） 與商業夥伴、可靠的附屬公司及廣告商共享，以作上述用途。'
      }, {
        type: 'content',
        hkText: '3. 教圖可能會將個人資料透露及分享予下列第三方機構。由於互聯網屬全球性，客戶接納及同意將你的個人資料轉交至全球其他國家，包括中國、加拿大、馬來西亞、新加坡、英國、美國以及一些可能未如香港訂立相同資料保護法例的地區。教圖可能將客戶的個人資料與下列各方分享：'
      }, {
        type: 'content',
        hkText: '　3.1 集團公司或已收購本公司業務任何部分的任何機構；'
      }, {
        type: 'content',
        hkText: '　3.2 服務供應商 （包括開發或寄存本網站，或為本公司提供郵件清單服務者）；'
      }, {
        type: 'content',
        hkText: '　3.3 第三方搜尋引擎，其可能將用戶檔案頁及用戶名稱預設為用戶檔案頁URL的一部分；'
      }, {
        type: 'content',
        hkText: '　3.4 在法律規定及容許的情況下；'
      }, {
        type: 'content',
        hkText: '　3.5 在客戶的同意下，與第三方機構如用戶就讀、任教或任職的學校 （包括教師及校長）。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '保護客戶的個人資料'
      }, {
        type: 'content',
        hkText: '教圖會採取合適的資料收集、保存及處理方法，以及保安措施，保護客戶於本網站儲存的個人資料、用戶名稱、密碼、交易資料及數據免於未經授權的使用、更改、披露或破壞。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '我們如何共享，轉讓公開閣下的個人資料'
      }, {
        type: 'content',
        hkText: '1.事先獲得閣下的聲明或授權。'
      }, {
        type: 'content',
        hkText: '2.遵循當地法律法規或政府要求。'
      }, {
        type: 'content',
        hkText: '3.解决欺詐，安全問題，保證我們及閣下的合法權益。'
      }, {
        type: 'content',
        hkText: '4.我們可能會與我們關聯的集團公司和合作夥伴共享資訊，包含不僅限於帳戶資訊，訂單資訊，位置資訊和設備資訊，在共享這些資訊時我們會再次徵求閣下的同意。'
      }, {
        type: 'content',
        hkText: '5.本公司發生了資產合併、收購、重組或出售等情况。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '我們收集閣下個人資料的用途'
      }, {
        type: 'content',
        hkText: '1.本公司從閣下收集的個人資料會因收集資料的情况而定，閣下的個人資料大概會用於：'
      }, {
        type: 'content',
        hkText: '2.閣下授權提供給本公司的用途；'
      }, {
        type: 'content',
        hkText: '3.與閣下提供給本公司直接有關的用途；'
      }, {
        type: 'content',
        hkText: '4.任何閣下已授權同意的用途。'
      }, {
        type: 'content',
        hkText: '5.我們收集閣下的電話號碼，電郵地址，協力廠商登入憑證用於完成本軟件帳戶的登錄註冊，以保證本軟體功能的正常使用。'
      }, {
        type: 'content',
        hkText: '6.我們使用我們收集的資訊來提供運營和服務。 我們還使用我們收集的資訊來改進本軟件和為閣下提供個性化服務，以便閣下在使用本軟件時獲得更好的體驗。'
      }, {
        type: 'content',
        hkText: '7.我們使用閣下與我們共享或我們收集的資訊來進行研究、調查、產品測試和故障排除，以幫助我們運營和改進我們的產品和服務。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '如何删除個人資料和帳戶資訊'
      }, {
        type: 'content',
        hkText: '1.如確實需要註銷帳戶及删除全部個人資料，請使用ParentNet App 點開個人信息頁面點擊“刪除賬戶”，或與我們的客戶服務人員聯系。'
      }, {
        type: 'content',
        hkText: '2.如欲查閱、更正個人資料，或索取有關政策和常規以及本公司所持個人資料類別的資料，或删除個人資料和帳戶資訊，請以下列途徑提出要求：'
      }, {
        type: 'content',
        hkText: '3.郵寄：香港長沙灣永康街77號環薈中心10樓1-7室「ParentNet教圖」客戶服務部主管 收 電郵： developer@cctechhk.com'
      }, {
        type: 'content',
        hkText: '4.星期一至五 早上9時至晚上6時; 星期六、日及公眾假期休息'
      }, {
        type: 'content',
        hkText: '5.我們會於收到你的要求後40天內作出回應。本公司對閣下每次成功查閱個人資料，可酌收不時釐定之合理費用。然而，倘閣下確實是為作出合理更正而查閱個人資料，則將獲豁免有關費用。惟條例賦予某些豁免條款，可能適用於查閱及更改個人資料的申請。本公司亦可能會要求閣下親身提供身份證明，方可申請查閱或更改閣下的個人資料。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '＃保護兒童的個人資料'
      }, {
        type: 'content',
        hkText: '任何 18 歲以下欲瀏覽本網站的人士必須獲取家長或合法監護人的同意下才可進行以下活動：'
      }, {
        type: 'content',
        hkText: '1. 寄出任何個人身份的資料或有關他人的任何資料'
      }, {
        type: 'content',
        hkText: '2. 參加任何比賽、遊戲或抽獎'
      }, {
        type: 'content',
        hkText: '用戶取得同意後，應只提交姓氏及名字簡稱，以便在網站作公布。切勿使用全名。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '豁免'
      }, {
        type: 'content',
        hkText: '本政策指引並不限制資料當事人在《私隱條例》下享有的權利，可是在某些情況下仍可受到豁免，包括當資料當事人申請引用條例中關於查閱資料及限制資料用途時，如有關申請很可能對某些不同立場的公眾或社會利益構成損害，則毋須受有關規定所管限。這些利益包括保安、防衛及國際關係；罪案的防止或偵查；評稅或收稅；新聞活動；以及公眾健康方面的利益。'
      }, {
        type: 'content',
        hkText: '教圖有權保留隨時更改本政策的權利，惟事先會在網站主頁、電郵、傳真、書信或其他方法作出通知。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '要求查閱及更改資料'
      }, {
        type: 'content',
        hkText: '如客戶有任何關於私隱政策、本網站做法以及客戶使用本網站，請提供公司聯絡資料如：'
      }, {
        type: 'content',
        hkText: '1. 聯絡地址'
      }, {
        type: 'content',
        hkText: '2. 傳真'
      }, {
        type: 'content',
        hkText: '3. 教圖將根據條例規定的四十日內，對資料當事人的查詢或對修改資料的要求作出回應。'
      }, {
        type: 'content',
        hkText: '4. 可能會就查閱要求收取合理費用以作行政支出。'
      }, {
        type: 'hr',
        hkText: ''
      }, {
        type: 'subT',
        hkText: '條款'
      }, {
        type: 'content',
        hkText: '提醒客戶使用這些網站，代表同意接受本私隱政策。如有不同意本私隱政策，切勿使用這些網站。'
      }, {
        type: 'content',
        hkText: '提醒客戶在本私隱政策作出更改後繼續使用網站，代表客戶同意此等更改。客戶明白此網站可能提供其他網站的連結，教圖對該等網站的私隱做法一概不能控制或影響。'
      }]
    };
  },
  components: {},
  methods: {}
};